import { Route, RouteComponentProps, withRouter } from 'react-router-dom';

import { fomatParentPath } from '../../utils';
import { MResetPass } from "../../lib";


function MRouteResetPass(props: RouteComponentProps) {
  const parentPath: string = fomatParentPath(props);
  return (
    <>
      <Route weId={`_yzjs07`} path={`${parentPath}/passport/resetpass`} exact component={MResetPass} />
    </>
  )
}

export default withRouter(MRouteResetPass);
